import { connect } from 'react-redux';
import { selectors, actions } from '../redux';
import { selectors as streamSelectors } from '../../Stream';
import { streamId } from '../redux/constants';
import { getIsDeviationInitialized } from '../redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviationId = _a.collectibleDeviation.deviationId;
    var selectedFolderIds = selectors.getSelectedFolderIds(state, deviationId);
    return {
        errorMsg: streamSelectors.getErrorMsg(state, streamId),
        isInitialized: getIsDeviationInitialized(state, deviationId),
        selectedFolderIds: selectedFolderIds,
        selectedFolderCount: selectedFolderIds.length,
    };
};
var mapDispatchToProps = {
    commitCollections: actions.commitCollections,
    initializeDeviation: actions.initializeDeviation,
    requestClose: actions.requestClose,
    undoChanges: actions.undoChanges,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DesktopCollectionPanel.container.js.map